<!-- Hero Section -->
<section class="hero-section">
  <div class="w-10/12 sm:w-9/12 mx-auto py-16 lg:py-20 text-center">
    <h1 class="gradient-heading text-4xl lg:text-5xl font-bold mb-6">
      {{ "about_page.title" | translate }}
    </h1>
    <p class="text-lg lg:text-xl text-gray-600 max-w-2xl mx-auto">
      {{ "about_page.subtitle" | translate }}
    </p>
  </div>
</section>

<!-- Mission Section -->
<section class="mission-section py-12 lg:py-16">
  <div class="w-10/12 sm:w-9/12 mx-auto">
    <div class="mission-card p-8 lg:p-12">
      <div class="flex flex-col lg:flex-row items-center gap-8 lg:gap-16">
        <div class="flex-shrink-0">
          <div class="mission-icon">
            <ng-icon name="iconoirArchery" style="font-size: 2.5rem"></ng-icon>
          </div>
        </div>
        <div class="flex-1 text-center lg:text-left">
          <h2 class="gradient-heading text-3xl lg:text-4xl font-bold mb-4">
            {{ "about_page.mission_title" | translate }}
          </h2>
          <p class="text-gray-600 text-base lg:text-lg leading-relaxed">
            {{ "about_page.mission_text" | translate }}
          </p>
        </div>
      </div>
    </div>
  </div>
</section>

<!-- Story Section -->
<section class="story-section py-12 lg:py-16">
  <div class="w-10/12 sm:w-9/12 mx-auto">
    <div class="text-center mb-12">
      <h2 class="gradient-heading text-3xl lg:text-4xl font-bold mb-6">
        {{ "about_page.story_title" | translate }}
      </h2>
    </div>
    <div class="story-card p-8 lg:p-12 max-w-3xl mx-auto">
      <div class="flex items-start gap-6">
        <div class="story-timeline flex-shrink-0">
          <div class="timeline-dot"></div>
          <div class="timeline-line"></div>
          <div class="timeline-dot"></div>
        </div>
        <div>
          <p class="text-gray-600 text-base lg:text-lg leading-relaxed">
            {{ "about_page.story_text" | translate }}
          </p>
        </div>
      </div>
    </div>
  </div>
</section>

<!-- Leadership Team Section -->
<section class="team-section py-12 lg:py-16">
  <div class="w-10/12 sm:w-9/12 mx-auto">
    <div class="text-center mb-12">
      <h2 class="gradient-heading text-3xl lg:text-4xl font-bold">
        {{ "about_page.team_title" | translate }}
      </h2>
    </div>
    <div class="grid grid-cols-1 md:grid-cols-3 gap-8 max-w-4xl mx-auto">
      <!-- Milan -->
      <div class="team-card p-6 text-center">
        <div class="avatar avatar-purple-dark mx-auto mb-4">
          <ng-icon name="iconoirUser" class="text-4xl"></ng-icon>
        </div>
        <h4 class="text-lg font-bold text-gray-900 mb-1">
          {{ "about_page.team_milan.name" | translate }}
        </h4>
        <p class="text-sm text-gray-500">
          {{ "about_page.team_milan.role" | translate }}
        </p>
      </div>

      <!-- Miro -->
      <div class="team-card p-6 text-center">
        <div class="avatar avatar-purple-mid mx-auto mb-4">
          <ng-icon name="iconoirUser" class="text-4xl"></ng-icon>
        </div>
        <h4 class="text-lg font-bold text-gray-900 mb-1">
          {{ "about_page.team_miro.name" | translate }}
        </h4>
        <p class="text-sm text-gray-500">
          {{ "about_page.team_miro.role" | translate }}
        </p>
      </div>

      <!-- Richard -->
      <div class="team-card p-6 text-center">
        <div class="avatar avatar-purple-light mx-auto mb-4">
          <ng-icon name="iconoirUser" class="text-4xl"></ng-icon>
        </div>
        <h4 class="text-lg font-bold text-gray-900 mb-1">
          {{ "about_page.team_richard.name" | translate }}
        </h4>
        <p class="text-sm text-gray-500">
          {{ "about_page.team_richard.role" | translate }}
        </p>
      </div>
    </div>
  </div>
</section>

<!-- European Values Section -->
<section class="values-section py-12 lg:py-16">
  <div class="w-10/12 sm:w-9/12 mx-auto">
    <div class="values-card p-8 lg:p-12 max-w-3xl mx-auto text-center">
      <div class="values-icon mx-auto mb-6">
        <ng-icon name="iconoirBookStack" style="font-size: 2.5rem"></ng-icon>
      </div>
      <h2 class="gradient-heading text-3xl lg:text-4xl font-bold mb-4">
        {{ "about_page.values_title" | translate }}
      </h2>
      <p class="text-gray-600 text-base lg:text-lg leading-relaxed">
        {{ "about_page.values_text" | translate }}
      </p>
    </div>
  </div>
</section>

<!-- Stats Section -->
<section class="stats-section py-12 lg:py-16">
  <div class="w-10/12 sm:w-9/12 mx-auto">
    <div class="text-center mb-12">
      <h2 class="gradient-heading text-3xl lg:text-4xl font-bold">
        {{ "about_page.stats_title" | translate }}
      </h2>
    </div>
    <div class="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-5 gap-6">
      <div class="stat-card p-6 text-center">
        <span class="stat-value">2K+</span>
        <span class="stat-label">Deployments</span>
      </div>
      <div class="stat-card p-6 text-center">
        <span class="stat-value">20+</span>
        <span class="stat-label">Countries</span>
      </div>
      <div class="stat-card p-6 text-center">
        <span class="stat-value">250M+</span>
        <span class="stat-label">Sessions</span>
      </div>
      <div class="stat-card p-6 text-center">
        <span class="stat-value">90%</span>
        <span class="stat-label">Retention</span>
      </div>
      <div class="stat-card p-6 text-center col-span-2 md:col-span-1 lg:col-span-1">
        <span class="stat-value">3.2X</span>
        <span class="stat-label">Expansion</span>
      </div>
    </div>
  </div>
</section>

<!-- CTA Section -->
<section class="cta-section py-12 lg:py-16">
  <div class="w-10/12 sm:w-9/12 mx-auto text-center">
    <app-get-demo></app-get-demo>
  </div>
</section>
